import React from 'react';
import { Pie } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';

Chart.register(ArcElement, Tooltip, Legend);

const SurveyPieChart = ({ optionList, colors }) => {
  if (!optionList || optionList.length === 0) return null;

  const data = {
    labels: optionList.map(opt => opt.option_text),
    datasets: [
      {
        data: optionList.map(opt => opt.count),
        backgroundColor: colors,
        borderWidth: 1
      }
    ]
  };

  return (
    <Pie
      data={data}
      options={{
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              boxWidth: 18,
              font: { size: 13 },
              padding: 18 // más espacio entre los ítems de la leyenda
            }
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                const label = context.label || '';
                const value = context.parsed || 0;
                return `${label}: ${value}`;
              }
            }
          }
        },
        layout: {
          padding: { top: 10, bottom: 40 } // más espacio abajo para la leyenda
        },
        maintainAspectRatio: false, // Permite que el gráfico use todo el alto del contenedor
        responsive: true
      }}
      width="100%"
      height="100%"
    />
  );
};

SurveyPieChart.propTypes = {
  optionList: PropTypes.arrayOf(
    PropTypes.shape({
      option_text: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired
    })
  ).isRequired,
  colors: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default SurveyPieChart;
